if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.bindScrollSync();
      }

      isMobileGallery() {
        return window.matchMedia('(max-width: 749px)').matches;
      }

      getVisibleSlides(container) {
        return Array.from(container.children).filter((element) => element.offsetWidth > 0);
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        const container = this.querySelector('[role="document"]');

        if (this.isMobileGallery()) {
          const slides = this.getVisibleSlides(container);
          const activeIndex = slides.indexOf(activeMedia);
          if (activeIndex > -1) {
            this.currentSlideIndex = activeIndex;
            container.scrollLeft = activeIndex * container.clientWidth;
            this.updateActiveDot(activeIndex);
          }
        } else {
          activeMedia.scrollIntoView();
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      updateActiveDot(index) {
        const dots = this.querySelectorAll('.product-media-modal__dot');
        if (!dots.length) return;
        dots.forEach((dot, i) => {
          dot.classList.toggle('product-media-modal__dot--active', i === index);
        });
      }

      bindScrollSync() {
        const container = this.querySelector('[role="document"]');
        if (!container) return;
        if (this.scrollHandler) container.removeEventListener('scroll', this.scrollHandler);
        this.scrollHandler = () => {
          if (!this.isMobileGallery() || !container.clientWidth) return;
          clearTimeout(this.scrollTimeout);
          this.scrollTimeout = setTimeout(() => {
            const index = Math.round(container.scrollLeft / container.clientWidth);
            const slides = this.getVisibleSlides(container);
            if (index < 0 || index >= slides.length) return;
            if (index !== this.currentSlideIndex) {
              this.currentSlideIndex = index;
              window.pauseAllMedia();
            }
            this.updateActiveDot(index);
            slides.forEach((slide, i) => slide.classList.toggle('active', i === index));
          }, 100);
        };
        container.addEventListener('scroll', this.scrollHandler, { passive: true });
      }
    }
  );
}
